/* tidecrab: Alternating claws and leg pairs carry the scuttle.
 * Eight authored 16x16 poses; palette and gameplay bounds are unchanged. */

export const tidecrab_0 = [
  '................',
  '................',
  '................',
  '................',
  '.....e....e.....',
  'o.o..o....o.....',
  'nNo.oooooooo.o.o',
  '.o.onmmmmmmnooNn',
  '.o.oNNnnNNNNo.o.',
  '..NoNNNNNNNNoN..',
  '....oooooooo....',
  '...N.N....N.N...',
  '.o............o.',
  '...o........o...',
  '................',
  '................',
];

export const tidecrab_1 = [
  '................',
  '................',
  '................',
  '................',
  'o.o..e....e.....',
  'nNo..o....o.....',
  '.o..oooooooo.o.o',
  '...onmmmmmmnooNn',
  '...oNNnnNNNNo.o.',
  '.oNoNNNNNNNNoNo.',
  '....oooooooo....',
  '...N.N....N.N...',
  '..o..........o..',
  '....o......o....',
  '................',
  '................',
];

export const tidecrab_2 = [
  '................',
  '................',
  '................',
  '................',
  'o.o..e....e.....',
  'nNo..o....o..o.o',
  '.o..oooooooo.oNn',
  '...onmmmmmmno.o.',
  '...oNNnnNNNNo...',
  '..NoNNNNNNNNoN..',
  '.o..oooooooo..o.',
  '...N.N....N.N...',
  '...o........o...',
  '.....o....o.....',
  '................',
  '................',
];

export const tidecrab_3 = [
  '................',
  '................',
  '................',
  '................',
  '.....e....e.....',
  'o.o..o....o..o.o',
  'nNo.oooooooo.oNn',
  '.o.onmmmmmmno.o.',
  '...oNNnnNNNNo...',
  '.oNoNNNNNNNNoNo.',
  '....oooooooo....',
  '...N.N....N.N...',
  '..o..........o..',
  '....o......o....',
  '................',
  '................',
];

export const tidecrab_4 = [
  '................',
  '................',
  '................',
  '................',
  '.....e....e.....',
  '.....o....o..o.o',
  'o.o.oooooooo.oNn',
  'nNoonmmmmmmno.o.',
  '.o.oNNnnNNNNo.o.',
  '..NoNNNNNNNNoN..',
  '....oooooooo....',
  '...N.N....N.N...',
  '.o............o.',
  '...o........o...',
  '................',
  '................',
];

export const tidecrab_5 = [
  '................',
  '................',
  '................',
  '................',
  '.....e....e..o.o',
  '.....o....o..oNn',
  'o.o.oooooooo..o.',
  'nNoonmmmmmmno...',
  '.o.oNNnnNNNNo...',
  '.oNoNNNNNNNNoNo.',
  '....oooooooo....',
  '...N.N....N.N...',
  '..o..........o..',
  '....o......o....',
  '................',
  '................',
];

export const tidecrab_6 = [
  '................',
  '................',
  '................',
  '................',
  '.....e....e..o.o',
  'o.o..o....o..oNn',
  'nNo.oooooooo..o.',
  '.o.onmmmmmmno...',
  '...oNNnnNNNNo...',
  '..NoNNNNNNNNoN..',
  '.o..oooooooo..o.',
  '...N.N....N.N...',
  '...o........o...',
  '.....o....o.....',
  '................',
  '................',
];

export const tidecrab_7 = [
  '................',
  '................',
  '................',
  '................',
  'o.o..e....e.....',
  'nNo..o....o..o.o',
  '.o..oooooooo.oNn',
  '...onmmmmmmno.o.',
  '...oNNnnNNNNo...',
  '.oNoNNNNNNNNoNo.',
  '....oooooooo....',
  '...N.N....N.N...',
  '..o..........o..',
  '....o......o....',
  '................',
  '................',
];
